export enum ClaimStatusId {
  validated = 1,
  paid = 2,
  cancelled = 3,
}
